import { jsx as _jsx } from "react/jsx-runtime";
import * as React from 'react';
import { Suspense, useEffect, useState } from 'react';
import { useAppSelector } from 'shared/hooks/redux/hooks';
import { MessageBox } from 'shared/components/dialogs/message-box';
const RealDialog = React.lazy(async () => {
    const { ConfiguredByWizard } = await import(
    // webpackChunkName: 'baxi-master'
    './configured-by-wizard-dialog');
    return { default: ConfiguredByWizard };
});
export function BaxiSettingsMaster() {
    const open = useAppSelector((state) => state.configured_dialog.open);
    const [wasOpen, setWasOpen] = useState(false);
    useEffect(() => {
        if (open) {
            setWasOpen(true);
        }
    }, [open]);
    if (!wasOpen)
        return null;
    return (_jsx(Suspense, { fallback: _jsx(MessageBox, { open: true, isInfo: true, title: "\u0417\u0430\u0433\u0440\u0443\u0437\u043A\u0430..." }), children: _jsx(RealDialog, {}) }));
}
